module.exports = __webpack_public_path__ + "static/media/zola_weddings_app_icon@2x.d180bb7d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/footer/zola_weddings_app_icon@2x.png
 ** module id = 2026
 ** module chunks = 50
 **/